var map = {
	"./json": 856,
	"./json.jsx": 856,
	"./md": 1087,
	"./md.jsx": 1087
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 855;



//////////////////
// WEBPACK FOOTER
// ../wrappers ^\.\/.*$
// module id = 855
// module chunks = 0